module.exports = __webpack_public_path__ + "static/media/MHRP09N0020.c76c724b.svg";